import { useEffect } from 'react';
import {
  QueryConfig,
  QueryFunction,
  QueryKey,
  QueryResult,
  TypedQueryFunction,
  TypedQueryFunctionArgs,
  useQuery as _useQuery,
} from 'react-query';

import { mockRequest } from '/debug/mocks';
import { mockSettingsStorage } from '/debug/mocks/storage';
import { QueryMockConfig } from '/debug/mocks/types';

export function useQuery<TResult, TError, TArgs extends TypedQueryFunctionArgs>(
  queryKey: readonly QueryKey[],
  queryFn: TypedQueryFunction<TResult, TArgs>,
  queryConfig?: QueryConfig<TResult, TError> & { mock?: QueryMockConfig },
): QueryResult<TResult, TError>;
export function useQuery<TResult = unknown, TError = unknown>(
  queryKey: readonly QueryKey[],
  queryFn: QueryFunction<TResult>,
  queryConfig?: QueryConfig<TResult, TError> & { mock?: QueryMockConfig },
): QueryResult<TResult, TError>;
export function useQuery<TResult, TError>(
  queryKey: readonly QueryKey[],
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  queryFn: any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  queryConfig: any,
): QueryResult<TResult, TError> {
  const mockConf = queryConfig?.mock;

  // Automatically refetch the query when the mock setting changes
  const mockSetting = mockSettingsStorage.useValue(mockConf);

  const query: QueryResult<TResult, TError> = _useQuery(queryKey, mockRequest(queryFn, mockConf), queryConfig);

  useEffect(() => {
    if (queryConfig?.enabled) {
      query.refetch();
    }
  }, [mockSetting]);

  return query;
}
